import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Button, CellContent } from "@gemini/ui";
import { getDocumentCookie, refreshToken, } from "@aviv-unified-frontend/runtime/authentication";
import { useBrand } from "@aviv-unified-frontend/runtime/brand";
import { useLocale } from "@aviv-unified-frontend/runtime/i18n";
import { BRAND_CONFIGURATION } from "../../../../configs/brands";
import { List } from "../List";
import { createTabPanel } from "./createTabPanel";
export const DebugTabPanel = createTabPanel({
    label: "Debug",
    description: "Debugging information and actions",
    Component() {
        const { id } = useBrand();
        const { language } = useLocale();
        return (_jsxs(_Fragment, { children: [_jsx(List, { items: [
                        {
                            key: id,
                            title: "Brand",
                        },
                        {
                            key: language,
                            title: "Language",
                        },
                    ], renderItem: ({ key, title }) => (_jsx(CellContent, { title: title, description: key }, key)) }), _jsx(List, { items: ACTION_ITEMS, renderItem: ({ action, name, key, description, disabled }) => (_jsxs(Box, { display: "flex", flexDirection: "column", children: [_jsx(Box, { as: "p", typography: "typography.body.12.regular", children: !disabled
                                    ? `${description}`
                                    : "You can't perform this action." }), _jsx(Button, { size: "32", isDisabled: disabled, type: "button", onPress: action, children: name })] }, key)) })] }));
    },
});
const unsafe_accessToken = getDocumentCookie(BRAND_CONFIGURATION.authentication?.cookies.accessToken);
const ACTION_ITEMS = [
    {
        id: "RefreshToken",
        action: () => {
            refreshToken(BRAND_CONFIGURATION.authentication?.urls.refresh ?? "");
        },
        disabled: !unsafe_accessToken,
        name: "Refresh token",
        description: "Refresh the current user token.",
        key: "RefreshToken",
    },
    {
        id: "ThrowAnError",
        action: () => {
            throw new Error("This is a test error.");
        },
        name: "Throw an error",
        description: "Throw a test error.",
        key: "ThrowAnError",
    },
];
